import { EnvelopeIcon as ReadEmailIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

type Props = {
  email: string;
};

export const ForgotPasswordSent = ({ email }: Props) => {
  return (
    <div className="flex w-80 flex-col text-content-primary">
      <ReadEmailIcon
        width="40"
        height="40"
        className="mb-5 flex size-10 self-center stroke-content-primary stroke-1.5"
      />
      <h1 className="mb-6 text-center text-[2rem] font-medium tracking-[0.01rem]">
        Check your email
      </h1>
      <p className="mb-6 text-center">
        We sent a password reset link to
        <br />
        <span className="font-medium text-feedback-info">{email}</span>
      </p>
      <p className="text-center">
        Didn&apos;t receive the email?{' '}
        <Link
          className="font-medium text-feedback-info hover:text-content-brand"
          to="/passwords/forgot"
        >
          Click to resend
        </Link>
      </p>
    </div>
  );
};
